import {getBlogPage} from '../BlogPage/BlogPage.duck';
import {termsOfUseSlug} from '../../marketplace-custom-config';

export const loadData = () => (dispatch, getState) => {
  return dispatch(getBlogPage(termsOfUseSlug));
};



// WEBPACK FOOTER //
// ./src/containers/AuthenticationPage/AuthenticationPage.duck.js